import { connect } from "react-redux";
import actionCreators from "../../redux/actionCreators";
import api from "../../redux/api";
import { getSocialComments, getSocialLikes, getWaitingComments, getWaitingLikes } from "../../redux/selectors";
import Post from "./post";
const mapStateToProps = (state) => ({
    socialComments: getSocialComments(state),
    socialLikes: getSocialLikes(state),
    waitingComments: getWaitingComments(state),
    waitingLikes: getWaitingLikes(state)
});
const mapDispatchToProps = (dispatch) => ({
    onLoadComments: (nodeId, documentId) => {
        dispatch(actionCreators.setWaitingComments(nodeId, documentId, true));
        dispatch(actionCreators.getComments(nodeId, documentId));
    },
    onLoadLikes: (nodeId, documentId) => {
        dispatch(actionCreators.setWaitingLikes(nodeId, documentId, true));
        dispatch(actionCreators.getLikes(nodeId, documentId));
    },
    onGetVideoUrl: (data) => api.buildVideoContentValueUrl(data.NodeId, data.Id),
    onGetAudioUrl: (data) => api.buildAudioContentValueUrl(data.NodeId, data.Id)
});
export default connect(mapStateToProps, mapDispatchToProps)(Post);
